module.exports = ".graph-border {\r\n    border: 1px solid #BBB;\r\n}\r\n\r\n.text-all-count {\r\n    font-size: 0.8em;\r\n    margin-right: 40px;\r\n}\r\n\r\n.graph-div {\r\n    display: block;\r\n    width: 800px;\r\n    margin: auto;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/a-graph/a-graph.component.css
// module id = ./src/app/parts/a-graph/a-graph.component.css
// module chunks = main